import { Injectable } from '@angular/core';
import {Endpoints} from "../../customs/endpoints";
import {HttpClient} from "@angular/common/http";
import {CommonResponse} from "../../customs/_models/Response";
import {PocDTO} from "../../customs/_models/Contact";

@Injectable({
  providedIn: 'root'
})
export class PocService {


    constructor(
        private endpoints: Endpoints,
        private http : HttpClient) { }

    public findAll(){
        console.log(this.endpoints.client_poc_base_endpoint)
        return this.http.get<CommonResponse>(this.endpoints.client_poc_base_endpoint)
    }

    public save(element: PocDTO) {
        return this.http.post<CommonResponse>(this.endpoints.client_poc_base_endpoint, element);
    }

    public update(element: PocDTO) {
        return this.http.put<CommonResponse>(this.endpoints.client_poc_base_endpoint, element);
    }

    delete(id: number) {
        return this.http.delete<boolean>(`${this.endpoints.client_poc_base_endpoint}/${id}`)
    }
}
